module.exports = __webpack_public_path__ + "static/media/warning.f45f31a9.svg";